import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";

const AssignKeyword = (props) => {
    const {assignKeywordModel,assignToKeywordToggleModel,processLinesFields,assignKeywordSeleced,assignKeywordValueChangeHAndler,
        assignKeywordValueHandler} = props;
    const {keyword,keyword_value,status,keyword_value_back,id} = processLinesFields;

    let keywordJson = keyword_value.value;
    let keyworkFields = ["PRE CONDITIONS"];
    if(keywordJson && keywordJson !== '') {
        // keywordJson = JSON.parse(keywordJson);
         Object.keys(keywordJson).map(function(key) {
            // console.log(key);
            keyworkFields.push(key);
        })
    }
    // console.log(assignKeywordSeleced);
    return (
		<Modal size="md" show={assignKeywordModel} dialogClassName="modal-dialog modal-xs height-auto">
            <Modal.Header>
                <h4 className="modal-title secondary_color pl-2 mb-0"> Assign Keyword </h4>
            </Modal.Header>
            <Modal.Body>
                <div className="row m-2">
                <div className="selectgroup-pills w-100 border-bottom pb-2 display-flex">
                    { keyworkFields ?
                        keyworkFields.map((item,ind) => {
                            return (
                                <label className="selectgroup-item mb-1" >
                                    <input type="radio" name="window" value={item} checked={assignKeywordSeleced===item ? true : false} 
                                        className="selectgroup-input" onChange={e=>assignKeywordValueChangeHAndler(item)}/>
                                    <span className="selectgroup-button">{item.toUpperCase()}</span>
                                </label>
                            )
                        })
                    : null }
                </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                    <a onClick={assignToKeywordToggleModel} className="btn btn-border border-default mr-2"> Cancel </a> 
                    <button onClick={assignKeywordValueHandler} disabled={assignKeywordSeleced === ""?true:false} className="btn primary_bg"> Assign </button> 
                </div>
            </Modal.Footer>
		</Modal>
	);
}

export default AssignKeyword;